import type { IconData } from '@stacksjs/iconify-core'

export const folder: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M472 472H40a24.03 24.03 0 0 1-24-24V64a24.03 24.03 0 0 1 24-24h186.667a23.935 23.935 0 0 1 22.154 14.77L269.333 104H472a24.03 24.03 0 0 1 24 24v320a24.03 24.03 0 0 1-24 24M48 440h416V136H248l-26.667-64H48Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default folder
